import { createLinkMatcherWithRegExp } from "@lexical/react/LexicalAutoLinkPlugin";

export const urlRegex =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const emailRegex =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

export const linkMatchers = [
  createLinkMatcherWithRegExp(urlRegex, (text) =>
    text.startsWith("http") ? text : `https://${text}`,
  ),
  createLinkMatcherWithRegExp(emailRegex, (text) => `mailto:${text}`),
];
